import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  ArrowRight, 
  ArrowLeft, 
  Users, 
  Calendar, 
  Utensils, 
  Coffee, 
  Cake, 
  Truck,
  CheckCircle,
  Sparkles,
  Calculator,
  Send,
  RotateCcw,
  Salad,
  Beef,
  Fish,
  Leaf,
  Soup,
  Cookie,
  Wine,
  HandPlatter,
  ChevronDown,
  Loader2,
  AlertCircle
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Checkbox } from '../components/ui/checkbox';

const BuffetkoneePage = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [selections, setSelections] = useState({
    eventType: null,
    guestCount: '',
    weddingMenu: null,
    starters: [],
    coldBuffet: [],
    salads: [],
    mainCourses: {
      kana: { selected: false, dish: '', sauce: '' },
      possu: { selected: false, dish: '', sauce: '' },
      harka: { selected: false, dish: '', sauce: '' },
      kala: { selected: false, dish: '', sauce: '' },
      kasvis: { selected: false, dish: '' }
    },
    sides: [],
    breads: [],
    spreads: [],
    wantsDessert: null,
    desserts: [],
    drinks: [],
    services: {
      tarjoilu: { selected: false, hours: 4 },
      kattaus: false
    },
    delivery: {
      kuljetus: false,
      takaisinvienti: false
    },
    contact: {
      name: '',
      email: '',
      phone: '',
      date: '',
      message: ''
    }
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [expandedWeddingMenu, setExpandedWeddingMenu] = useState(null);

  // Wedding menu packages
  const weddingMenus = [
    {
      id: 'haamenu1',
      name: 'Häämenu 1 - Klassinen',
      pricePerPerson: 55,
      description: 'Perinteinen ja tyylikäs',
      items: {
        alkupalat: ['Savulohimousse', 'Kauden salaatti'],
        paaruoat: ['Paahtopaisti punaviini­kastikkeella', 'Kermaperunat', 'Kauden kasvikset'],
        jalkiruoat: ['Suklaakakku marjoilla', 'Kahvi ja konvehdit']
      }
    },
    {
      id: 'haamenu2',
      name: 'Häämenu 2 - Moderni',
      pricePerPerson: 65,
      description: 'Raikas ja nykyaikainen',
      items: {
        alkupalat: ['Burrata tomaatti-basilikalla', 'Rapea vihersalaatti'],
        paaruoat: ['Yrttimarinoidut kananpojan koivet', 'Tryffelirisotto', 'Paahdetut juurekset'],
        jalkiruoat: ['Sitruuna-marenkitartaletti', 'Kahvi ja petit fours']
      }
    },
    {
      id: 'haamenu3',
      name: 'Häämenu 3 - Premium',
      pricePerPerson: 79,
      description: 'Ylellinen juhla-ateria',
      items: {
        alkupalat: ['Graavilohi tillikastikkeella', 'Katkarapu-avokadosalaatti'],
        paaruoat: ['Naudan sisäfilee bearnaise­kastikkeella', 'Duchesse-perunat', 'Parsaa ja tryffeliä'],
        jalkiruoat: ['Crème brûlée', 'Juustolautanen', 'Kahvi ja tryffelit']
      }
    },
    {
      id: 'haamenu4',
      name: 'Häämenu 4 - Kasvis',
      pricePerPerson: 52,
      description: 'Kasvisruokailijan juhlamenu',
      items: {
        alkupalat: ['Vuohenjuusto-punajuuritartar', 'Quinoa-tabbouleh'],
        paaruoat: ['Täytetyt portobello-sienet', 'Bataattigratiini', 'Grillatut kasvikset'],
        jalkiruoat: ['Vegaaninen suklaatartaletti', 'Tuore marjakiisseli', 'Kahvi']
      }
    }
  ];

  // Price data (hidden from customer)
  const prices = {
    starters: 2.50,
    coldBuffet: 6.00,
    salads: 4.50,
    mainCourses: {
      kana: 12.50,
      possu: 12.50,
      harka: 16.50,
      kala: 16.50,
      kasvis: 10.50
    },
    sides: 1.50,
    breads: 0.75,
    spreads: 0.75,
    desserts: {
      mokkapala: 2,
      porkkanakakku: 2,
      juustokakku: 4.50,
      taytekakku: 4.50
    },
    drinks: {
      mehu: 1,
      kotikalja: 1,
      kahvi: 2.50,
      tee: 2.50
    },
    services: {
      tarjoiluPerHour: 36,
      kattausPerPerson: 1
    },
    deliveryPerDirection: 25
  };

  // Options data
  
  // SORMISYÖTÄVIÄ/ALKUPALAT (2,50€/kpl)
  const starterOptions = [
    { value: 'savupororieskaset', label: 'Savupororieskaset ja puolukkadippi' },
    { value: 'briossikierteet', label: 'Briossikierteet yrtti-juustotäyte' },
    { value: 'hapankorppurullat', label: 'Hapankorppu rullat sienimousse' },
    { value: 'ilmakuivattu-kinkku', label: 'Ilmakuivattua kinkkua, hunajamelonia' },
    { value: 'marinoidut-oliivit', label: 'Hunajalla ja sitruunalla marinoituja oliiveja' },
    { value: 'pikkeloidyt-kasvikset', label: 'Pikkelöidyt kasvikset' },
    { value: 'marinoidut-punasipulit', label: 'Marinoidut punasipulit' },
    { value: 'marinoidut-herkkusienet', label: 'Marinoidut herkkusienet' },
    { value: 'tuulihatut-lohimousse', label: 'Tuulihatut lohimousse täytteellä' },
    { value: 'tuulihatut-avokado', label: 'Tuulihatut avokado-feta-basilikamousse' },
    { value: 'tuulihatut-savuporo', label: 'Tuulihatut savuporomousse täytteellä' }
  ];

  // KALA/LIHA KYLMÄPÖYTÄ (6,00€/kpl)
  const coldBuffetOptions = [
    { value: 'lamminsavulohi', label: 'Lämminsavulohi (sis. tilli-limekastike)' },
    { value: 'kylmasavulohi', label: 'Kylmäsavulohi (sis. tilli-limekastike)' },
    { value: 'punajuurigraavattulohi', label: 'Punajuurigraavattu lohi (sis. tilli-limekastike)' },
    { value: 'ginigraavattulohi', label: 'Ginigraavattu lohi (sis. tilli-limekastike)' },
    { value: 'paahtopaisti-mustaherukka', label: 'Paahtopaisti mustaherukkahillokkeella' },
    { value: 'porsaanfile-sinappi', label: 'Porsaanfile sinappiyrttikuorrutteella' }
  ];

  // SALAATIT (4,50€/kpl)
  const saladOptions = [
    { value: 'vihersalaatti-meloni', label: 'Vihersalaatti melonilla ja rypäleillä' },
    { value: 'viherversosalaatti', label: 'Viherversosalaatti marinoidulla kurkulla, appelsiinilla ja purjolla' },
    { value: 'leipajuustosalaatti', label: 'Leipäjuustosalaatti mansikoilla ja kurkulla' },
    { value: 'caesarsalaatti-kana', label: 'Caesarsalaatti kanalla' },
    { value: 'caesarsalaatti-tofu', label: 'Caesarsalaatti paahdetulla tofulla' },
    { value: 'maalaissalaatti', label: 'Maalaissalaatti pekonimurulla' },
    { value: 'tomaatti-mozzarella', label: 'Basilika marinoitu tomaatti-mozzarella salaatti' },
    { value: 'kolmen-juuston-pasta', label: 'Kolmen juuston pastasalaatti' },
    { value: 'kanapastasalaatti', label: 'Hedelmäinen kanapastasalaatti' },
    { value: 'punajuurisalaatti-rucola', label: 'Paahdettu punajuurisalaatti rucolalla' },
    { value: 'paahdettu-perunasalaatti', label: 'Paahdettu perunasalaatti (kirkas)' },
    { value: 'kevatsipuli-peruna', label: 'Kevätsipuli-perunasalaatti' },
    { value: 'green-goddess-peruna', label: 'Green goddess perunasalaatti savulohella' },
    { value: 'romesco-peruna', label: 'Romesco perunasalaatti' },
    { value: 'kukkakaali-ananas', label: 'Kukkakaali-ananassalaatti jogurttikastikkeella' },
    { value: 'metsasienisalaatti', label: 'Pikkelöity metsäsienisalaatti' },
    { value: 'kreikkalainen', label: 'Kreikkalainen salaatti yrttiöljyllä' },
    { value: 'tabbouleh', label: 'Tabbouleh-salaatti' }
  ];

  // PÄÄRUOAT JA KASTIKKEET
  const mainCourseOptions = {
    kana: [
      { value: 'broilerin-sisafile', label: 'Broilerin sisäfile' },
      { value: 'broilerin-paistileike', label: 'Broilerin paistileike' }
    ],
    possu: [
      { value: 'ylikypsaa-possunniskaa', label: 'Ylikypsää possunniskaa' },
      { value: 'possun-ulkofile', label: 'Possun ulkofile' },
      { value: 'possun-poskea', label: 'Possun poskea' }
    ],
    harka: [
      { value: 'haranrinta', label: 'Yön yli haudutettua häränrintaa' },
      { value: 'paahtopaisti', label: 'Paahtopaisti' }
    ],
    kala: [
      { value: 'savulohi', label: 'Savulohi' },
      { value: 'uunilohi', label: 'Uunilohi' },
      { value: 'kuha', label: 'Kuha' }
    ],
    kasvis: [
      { value: 'falafel', label: 'Falafel pyörykät, minttujogurttikastike' },
      { value: 'gratinoidut-paprikat', label: 'Gratinoidut paprikat chevrejuustolla' },
      { value: 'punajuuriaurapaistos', label: 'Punajuuriaurapaistos' }
    ]
  };

  // Kastikkeet kategorioittain
  const sauceOptions = {
    kana: [
      { value: 'limoncello', label: 'Limoncellokastike' },
      { value: 'tomaatti-kerma', label: 'Tomaattinen kermakastike yrteillä ja parmesaanilla' },
      { value: 'pippuri-kana', label: 'Pippurikastike' },
      { value: 'paholaisen', label: 'Paholaisenkastike' }
    ],
    liha: [
      { value: 'viherpippuri', label: 'Viherpippurikastike' },
      { value: 'tumma-sipuli', label: 'Tumma sipulikastike' },
      { value: 'punaviini-timjami', label: 'Punaviinikastike timjamilla' },
      { value: 'kerma-liha', label: 'Kermakastike' }
    ],
    kala: [
      { value: 'yrtti-smetana', label: 'Yrttinen smetanakuorrute' },
      { value: 'valkoviini', label: 'Valkoviinikastike' },
      { value: 'hollandaise', label: 'Hollandaisekastike' }
    ]
  };

  // LISUKKEET (1,50€/kpl)
  const sideOptions = [
    { value: 'tillivoiperunat', label: 'Tillivoiperunat' },
    { value: 'paahtoperunat', label: 'Paahtoperunat yrttivoilla' },
    { value: 'kermaperunat', label: 'Kermaperunat' },
    { value: 'valkosipuliperunat', label: 'Valkosipuliperunat' },
    { value: 'uuden-sadon-perunat', label: 'Uuden sadon perunat' },
    { value: 'hunajaporkkanat', label: 'Hunajaiset rakuunaporkkanat' },
    { value: 'uunikasvikset', label: 'Uunikasvikset' },
    { value: 'kasvisgratiini', label: 'Kasvisgratiini' },
    { value: 'paistettu-riisi', label: 'Paistettu riisi' }
  ];

  // LEIPÄ (0,75€/kpl)
  const breadOptions = [
    { value: 'patonki', label: 'Patonki' },
    { value: 'focaccia', label: 'Focaccia' },
    { value: 'saaristolaisleipa', label: 'Saaristolaisleipä' },
    { value: 'kaurakierre', label: 'Kaurakierre' },
    { value: 'ruisleipa', label: 'Ruisleipä' }
  ];

  // LEVITTEET (0,75€/kpl)
  const spreadOptions = [
    { value: 'voi', label: 'Voi' },
    { value: 'margariini', label: 'Margariini' },
    { value: 'pestolevite', label: 'Pestolevite' },
    { value: 'ruohosipulilevite', label: 'Ruohosipulilevite' },
    { value: 'ruskistettu-voi', label: 'Ruskistettu voi' }
  ];

  const dessertOptions = [
    { value: 'mokkapala', label: 'Mokkapala' },
    { value: 'porkkanakakku', label: 'Porkkanakakku' },
    { value: 'juustokakku', label: 'Juustokakku' },
    { value: 'taytekakku', label: 'Täytekakku' }
  ];

  const drinkOptions = [
    { value: 'mehu', label: 'Mehu' },
    { value: 'kotikalja', label: 'Kotikalja' },
    { value: 'kahvi', label: 'Kahvi' },
    { value: 'tee', label: 'Tee' }
  ];

  // Calculate total price
  const calculatePrice = () => {
    const guests = parseInt(selections.guestCount) || 0;
    let total = 0;

    // Regular pricing for all events
    // Starters (alkupalat)
    total += selections.starters.length * prices.starters * guests;

    // Cold buffet (kylmäpöytä)
    total += selections.coldBuffet.length * prices.coldBuffet * guests;

    // Salads
    total += selections.salads.length * prices.salads * guests;

    // Main courses
    Object.keys(selections.mainCourses).forEach(key => {
      if (selections.mainCourses[key].selected && selections.mainCourses[key].dish) {
        total += prices.mainCourses[key] * guests;
      }
    });

    // Sides
    total += selections.sides.length * prices.sides * guests;

    // Breads
    total += selections.breads.length * prices.breads * guests;

    // Spreads (levitteet)
    total += selections.spreads.length * prices.spreads * guests;

    // Desserts
    selections.desserts.forEach(dessert => {
      total += prices.desserts[dessert] * guests;
    });

    // Drinks
    selections.drinks.forEach(drink => {
      total += prices.drinks[drink] * guests;
    });

    // Services
    if (selections.services.tarjoilu.selected) {
      total += prices.services.tarjoiluPerHour * selections.services.tarjoilu.hours;
    }
    if (selections.services.kattaus) {
      total += prices.services.kattausPerPerson * guests;
    }

    // Delivery (25€/suunta)
    if (selections.delivery.kuljetus) {
      total += prices.deliveryPerDirection;
    }
    if (selections.delivery.takaisinvienti) {
      total += prices.deliveryPerDirection;
    }

    return total;
  };

  // All possible steps
  const allSteps = [
    {
      id: 'eventType',
      title: 'Millainen tilaisuus?',
      subtitle: 'Valitse tilaisuuden tyyppi',
      icon: Calendar
    },
    {
      id: 'guestCount',
      title: 'Montako vierasta?',
      subtitle: 'Syötä henkilömäärä',
      icon: Users
    },
    {
      id: 'weddingMenu',
      title: 'Valitse häämenu',
      subtitle: 'Valmiit menuvaihtoehdot häihin',
      icon: Sparkles,
      weddingOnly: true
    },
    {
      id: 'starters',
      title: 'Sormisyötävät & Alkupalat',
      subtitle: 'Valitse alkupalat',
      icon: Utensils,
      regularOnly: true
    },
    {
      id: 'coldBuffet',
      title: 'Kylmäpöytä',
      subtitle: 'Kala & liha kylmänä',
      icon: Fish,
      regularOnly: true
    },
    {
      id: 'salads',
      title: 'Salaatit',
      subtitle: 'Valitse salaatit',
      icon: Salad,
      regularOnly: true
    },
    {
      id: 'mainCourses',
      title: 'Pääruoat',
      subtitle: 'Valitse pääruoat ja kastikkeet',
      icon: Beef,
      regularOnly: true
    },
    {
      id: 'sides',
      title: 'Lisukkeet',
      subtitle: 'Valitse lisukkeet',
      icon: Utensils,
      regularOnly: true
    },
    {
      id: 'breads',
      title: 'Leivät & Levitteet',
      subtitle: 'Valitse leivät ja levitteet',
      icon: Cookie,
      regularOnly: true
    },
    {
      id: 'desserts',
      title: 'Jälkiruoat',
      subtitle: 'Haluatko jälkiruoan?',
      icon: Cake,
      regularOnly: true
    },
    {
      id: 'drinks',
      title: 'Juomat',
      subtitle: 'Valitse juomat',
      icon: Coffee,
      regularOnly: true
    },
    {
      id: 'services',
      title: 'Lisäpalvelut',
      subtitle: 'Valitse lisäpalvelut',
      icon: HandPlatter
    },
    {
      id: 'delivery',
      title: 'Toimitus',
      subtitle: 'Nouto vai kuljetus?',
      icon: Truck
    },
    {
      id: 'contact',
      title: 'Yhteystiedot',
      subtitle: 'Täytä yhteystietosi',
      icon: Send
    }
  ];

  // Dynamic steps based on event type - all events use the same flow
  const steps = allSteps.filter(step => {
    // Hide wedding-only steps for all events (wedding menus removed)
    return !step.weddingOnly;
  });

  const handleMultiSelect = (stepId, value) => {
    const current = selections[stepId] || [];
    const updated = current.includes(value)
      ? current.filter(v => v !== value)
      : [...current, value];
    setSelections({ ...selections, [stepId]: updated });
  };

  const handleMainCourseToggle = (category) => {
    setSelections({
      ...selections,
      mainCourses: {
        ...selections.mainCourses,
        [category]: {
          ...selections.mainCourses[category],
          selected: !selections.mainCourses[category].selected,
          dish: !selections.mainCourses[category].selected ? '' : selections.mainCourses[category].dish
        }
      }
    });
  };

  const handleMainCourseDish = (category, dish) => {
    setSelections({
      ...selections,
      mainCourses: {
        ...selections.mainCourses,
        [category]: {
          ...selections.mainCourses[category],
          dish: dish
        }
      }
    });
  };

  const handleContactChange = (field, value) => {
    setSelections({
      ...selections,
      contact: { ...selections.contact, [field]: value }
    });
  };

  const canProceed = () => {
    const step = steps[currentStep];
    switch (step.id) {
      case 'eventType':
        return selections.eventType !== null;
      case 'guestCount':
        return parseInt(selections.guestCount) >= 10;
      case 'weddingMenu':
        return selections.weddingMenu !== null;
      case 'starters':
      case 'coldBuffet':
      case 'salads':
      case 'sides':
      case 'breads':
      case 'drinks':
        return true; // Optional steps
      case 'mainCourses':
        return Object.values(selections.mainCourses).some(m => m.selected && m.dish);
      case 'desserts':
        if (selections.wantsDessert === false) return true;
        if (selections.wantsDessert === true) return selections.desserts.length > 0;
        return selections.wantsDessert !== null;
      case 'services':
      case 'delivery':
        return true;
      case 'contact':
        return selections.contact.name && selections.contact.email && selections.contact.phone;
      default:
        return true;
    }
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
      // Scroll to top of form
      setTimeout(() => {
        window.scrollTo({ top: 200, behavior: 'smooth' });
      }, 100);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      // Scroll to top of form
      setTimeout(() => {
        window.scrollTo({ top: 200, behavior: 'smooth' });
      }, 100);
    }
  };

  const [submitStatus, setSubmitStatus] = useState('idle'); // idle | sending | error
  const [submitError, setSubmitError] = useState('');

  const buildQuotePayload = () => {
    const eventLabel =
      eventTypes.find((e) => e.value === selections.eventType)?.label || selections.eventType || '—';
    const list = [];
    list.push({ label: 'Tilaisuus', value: eventLabel });

    if (selections.weddingMenu) {
      list.push({ label: 'Hääpaketti', value: selections.weddingMenu });
    }
    if (selections.starters?.length) {
      list.push({ label: 'Alkupalat', value: selections.starters.join(', ') });
    }
    if (selections.coldBuffet?.length) {
      list.push({ label: 'Kylmä buffet', value: selections.coldBuffet.join(', ') });
    }
    if (selections.salads?.length) {
      list.push({ label: 'Salaatit', value: selections.salads.join(', ') });
    }
    Object.entries(selections.mainCourses || {}).forEach(([key, val]) => {
      if (val.selected && val.dish) {
        const sauce = val.sauce ? ` (${val.sauce})` : '';
        list.push({ label: `Pääruoka: ${mainCourseLabels[key] || key}`, value: `${val.dish}${sauce}` });
      }
    });
    if (selections.sides?.length) {
      list.push({ label: 'Lisukkeet', value: selections.sides.join(', ') });
    }
    if (selections.breads?.length) {
      list.push({ label: 'Leivät', value: selections.breads.join(', ') });
    }
    if (selections.spreads?.length) {
      list.push({ label: 'Levitteet', value: selections.spreads.join(', ') });
    }
    if (selections.wantsDessert) {
      list.push({ label: 'Jälkiruoka', value: selections.wantsDessert });
    }
    if (selections.desserts?.length) {
      list.push({ label: 'Jälkiruokavalinnat', value: selections.desserts.join(', ') });
    }
    if (selections.drinks?.length) {
      list.push({ label: 'Juomat', value: selections.drinks.join(', ') });
    }
    const services = [];
    if (selections.services?.tarjoilu?.selected) {
      services.push(`Tarjoilu (${selections.services.tarjoilu.hours} h)`);
    }
    if (selections.services?.kattaus) services.push('Kattaus');
    if (services.length) list.push({ label: 'Lisäpalvelut', value: services.join(', ') });
    const delivery = [];
    if (selections.delivery?.kuljetus) delivery.push('Kuljetus');
    if (selections.delivery?.takaisinvienti) delivery.push('Takaisinvienti');
    if (delivery.length) list.push({ label: 'Toimitus', value: delivery.join(', ') });

    return {
      name: selections.contact.name?.trim() || '',
      email: selections.contact.email?.trim() || '',
      phone: selections.contact.phone?.trim() || null,
      event_date: selections.contact.date?.trim() || null,
      guest_count: parseInt(selections.guestCount, 10) || null,
      delivery_address: null,
      estimated_total: `${calculatePrice().toFixed(2)} € (sis. alv 13,5%)`,
      selections: list,
      extra_notes: selections.contact.message?.trim() || null,
    };
  };

  const handleSubmit = async () => {
    setSubmitStatus('sending');
    setSubmitError('');
    try {
      const payload = buildQuotePayload();
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/catering-quote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || `Virhe (${res.status})`);
      }
      setSubmitStatus('idle');
      setIsSubmitted(true);
    } catch (err) {
      setSubmitStatus('error');
      setSubmitError(err.message || 'Lähetys epäonnistui. Yritä uudelleen.');
    }
  };

  const resetForm = () => {
    setCurrentStep(0);
    setSelections({
      eventType: null,
      guestCount: '',
      weddingMenu: null,
      starters: [],
      coldBuffet: [],
      salads: [],
      mainCourses: {
        kana: { selected: false, dish: '', sauce: '' },
        possu: { selected: false, dish: '', sauce: '' },
        harka: { selected: false, dish: '', sauce: '' },
        kala: { selected: false, dish: '', sauce: '' },
        kasvis: { selected: false, dish: '' }
      },
      sides: [],
      breads: [],
      spreads: [],
      wantsDessert: null,
      desserts: [],
      drinks: [],
      services: {
        tarjoilu: { selected: false, hours: 4 },
        kattaus: false
      },
      delivery: {
        kuljetus: false,
        takaisinvienti: false
      },
      contact: { name: '', email: '', phone: '', date: '', message: '' }
    });
    setExpandedWeddingMenu(null);
    setIsSubmitted(false);
  };

  const currentStepData = steps[currentStep];
  const progress = ((currentStep + 1) / steps.length) * 100;
  const totalPrice = calculatePrice();

  // Event type options
  const eventTypes = [
    { value: 'birthday', label: 'Syntymäpäivät' },
    { value: 'memorial', label: 'Muistotilaisuus' },
    { value: 'corporate', label: 'Yritystilaisuus' },
    { value: 'wedding', label: 'Häät / Juhlat' },
    { value: 'other', label: 'Muu tilaisuus' }
  ];

  // Main course labels
  const mainCourseLabels = {
    kana: 'Kana',
    possu: 'Possu',
    harka: 'Härkä',
    kala: 'Kala',
    kasvis: 'Kasvis'
  };

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white py-20">
        <div className="max-w-2xl mx-auto px-6">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 text-center border-2 border-green-200">
            <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <CheckCircle className="w-10 h-10 text-white" />
            </div>
            <h2 className="text-3xl font-bold text-stone-800 mb-4">Kiitos tarjouspyynnöstä!</h2>
            <p className="text-stone-600 mb-6">
              Olemme vastaanottaneet tilauksesi ja otamme sinuun yhteyttä 1-3 arkipäivän kuluessa vahvistaaksemme tilauksen.
            </p>
            
            <div className="bg-emerald-50 rounded-2xl p-6 mb-8 text-left">
              <h3 className="font-semibold text-stone-800 mb-3">Tilauksen yhteenveto:</h3>
              <div className="space-y-2 text-sm text-stone-600">
                <p><strong>Henkilömäärä:</strong> {selections.guestCount} henkilöä</p>
                <p><strong>Tilaisuus:</strong> {eventTypes.find(e => e.value === selections.eventType)?.label}</p>
              </div>
              <div className="mt-4 pt-4 border-t border-emerald-200">
                <div className="flex justify-between items-center">
                  <span className="font-semibold text-stone-800">Kokonaishinta:</span>
                  <span className="text-2xl font-bold text-emerald-600">{totalPrice.toFixed(2)}€</span>
                </div>
                <p className="text-xs text-stone-500 mt-1">sis. alv 13,5%</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={resetForm} variant="outline" className="border-2 border-stone-300 rounded-xl px-6 py-3">
                <RotateCcw className="w-4 h-4 mr-2" />
                Aloita alusta
              </Button>
              <Link to="/">
                <Button className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl px-6 py-3">
                  Takaisin etusivulle
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const renderStepContent = () => {
    switch (currentStepData.id) {
      case 'eventType':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {eventTypes.map((option) => {
              const isSelected = selections.eventType === option.value;
              return (
                <button
                  key={option.value}
                  onClick={() => setSelections({ ...selections, eventType: option.value })}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <span className={`font-medium ${isSelected ? 'text-emerald-700' : 'text-stone-800'}`}>
                    {option.label}
                  </span>
                </button>
              );
            })}
          </div>
        );

      case 'guestCount':
        return (
          <div className="max-w-xs">
            <Label className="text-stone-700 font-medium">Henkilömäärä</Label>
            <Input
              type="number"
              min="10"
              max="500"
              value={selections.guestCount}
              onChange={(e) => setSelections({ ...selections, guestCount: e.target.value })}
              className="mt-2 text-2xl font-bold text-center py-6 border-2 border-emerald-200 rounded-xl focus:border-emerald-400"
              placeholder="0"
            />
            <p className="text-sm text-stone-500 mt-2">Vähintään 10 henkilöä</p>
          </div>
        );

      case 'weddingMenu':
        return (
          <div className="space-y-4">
            {weddingMenus.map((menu) => {
              const isSelected = selections.weddingMenu === menu.id;
              const isExpanded = expandedWeddingMenu === menu.id;
              return (
                <div 
                  key={menu.id} 
                  className={`rounded-xl border-2 transition-all overflow-hidden ${
                    isSelected ? 'border-emerald-500 bg-emerald-50 shadow-lg' : 'border-stone-200'
                  }`}
                >
                  <button
                    onClick={() => {
                      setSelections({ ...selections, weddingMenu: menu.id });
                      setExpandedWeddingMenu(isExpanded ? null : menu.id);
                    }}
                    className="w-full p-4 flex items-center justify-between text-left"
                  >
                    <div className="flex-1">
                      <div className="flex items-center gap-3">
                        <span className={`font-bold text-lg ${isSelected ? 'text-emerald-700' : 'text-stone-800'}`}>
                          {menu.name}
                        </span>
                      </div>
                      <p className="text-sm text-stone-500 mt-1">{menu.description}</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <ChevronDown className={`w-5 h-5 text-stone-400 transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
                      <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                        isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                      }`}>
                        {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                      </div>
                    </div>
                  </button>
                  
                  {/* Expanded menu content */}
                  {isExpanded && (
                    <div className="px-4 pb-4 border-t border-stone-200 bg-white/50">
                      <div className="pt-4 space-y-3">
                        <div>
                          <h4 className="font-semibold text-emerald-700 text-sm uppercase tracking-wide">Alkupalat</h4>
                          <ul className="mt-1 text-stone-600 text-sm">
                            {menu.items.alkupalat.map((item, i) => (
                              <li key={i} className="flex items-center gap-2">
                                <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full"></span>
                                {item}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div>
                          <h4 className="font-semibold text-emerald-700 text-sm uppercase tracking-wide">Pääruoat</h4>
                          <ul className="mt-1 text-stone-600 text-sm">
                            {menu.items.paaruoat.map((item, i) => (
                              <li key={i} className="flex items-center gap-2">
                                <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full"></span>
                                {item}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div>
                          <h4 className="font-semibold text-emerald-700 text-sm uppercase tracking-wide">Jälkiruoat</h4>
                          <ul className="mt-1 text-stone-600 text-sm">
                            {menu.items.jalkiruoat.map((item, i) => (
                              <li key={i} className="flex items-center gap-2">
                                <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full"></span>
                                {item}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );

      case 'starters':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {starterOptions.map((option) => {
              const isSelected = selections.starters.includes(option.value);
              return (
                <button
                  key={option.value}
                  onClick={() => handleMultiSelect('starters', option.value)}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className={`font-medium ${isSelected ? 'text-emerald-700' : 'text-stone-800'}`}>
                      {option.label}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        );

      case 'coldBuffet':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {coldBuffetOptions.map((option) => {
              const isSelected = selections.coldBuffet.includes(option.value);
              return (
                <button
                  key={option.value}
                  onClick={() => handleMultiSelect('coldBuffet', option.value)}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className={`font-medium text-sm ${isSelected ? 'text-emerald-700' : 'text-stone-800'}`}>
                      {option.label}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        );

      case 'salads':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {saladOptions.map((option) => {
              const isSelected = selections.salads.includes(option.value);
              return (
                <button
                  key={option.value}
                  onClick={() => handleMultiSelect('salads', option.value)}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className={`font-medium ${isSelected ? 'text-emerald-700' : 'text-stone-800'}`}>
                      {option.label}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        );

      case 'mainCourses':
        return (
          <div className="space-y-4">
            {Object.keys(mainCourseOptions).map((category) => {
              const isSelected = selections.mainCourses[category].selected;
              const hasSauces = category !== 'kasvis';
              const sauceCategory = category === 'kana' ? 'kana' : (category === 'kala' ? 'kala' : 'liha');
              return (
                <div key={category} className={`rounded-xl border-2 transition-all ${
                  isSelected ? 'border-emerald-500 bg-emerald-50' : 'border-stone-200'
                }`}>
                  <button
                    onClick={() => handleMainCourseToggle(category)}
                    className="w-full p-4 flex items-center justify-between"
                  >
                    <span className={`font-semibold text-lg ${isSelected ? 'text-emerald-700' : 'text-stone-800'}`}>
                      {mainCourseLabels[category]}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </button>
                  
                  {isSelected && (
                    <div className="px-4 pb-4 space-y-3">
                      <div>
                        <label className="text-sm font-medium text-stone-600 mb-1 block">Valitse ruokalaji:</label>
                        <select
                          value={selections.mainCourses[category].dish}
                          onChange={(e) => handleMainCourseDish(category, e.target.value)}
                          className="w-full p-3 border-2 border-emerald-200 rounded-lg bg-white focus:border-emerald-400 focus:outline-none"
                        >
                          <option value="">Valitse ruokalaji...</option>
                          {mainCourseOptions[category].map((dish) => (
                            <option key={dish.value} value={dish.value}>{dish.label}</option>
                          ))}
                        </select>
                      </div>
                      
                      {hasSauces && (
                        <div>
                          <label className="text-sm font-medium text-stone-600 mb-1 block">Valitse kastike:</label>
                          <select
                            value={selections.mainCourses[category].sauce || ''}
                            onChange={(e) => setSelections({
                              ...selections,
                              mainCourses: {
                                ...selections.mainCourses,
                                [category]: {
                                  ...selections.mainCourses[category],
                                  sauce: e.target.value
                                }
                              }
                            })}
                            className="w-full p-3 border-2 border-emerald-200 rounded-lg bg-white focus:border-emerald-400 focus:outline-none"
                          >
                            <option value="">Valitse kastike...</option>
                            {sauceOptions[sauceCategory].map((sauce) => (
                              <option key={sauce.value} value={sauce.value}>{sauce.label}</option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );

      case 'sides':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {sideOptions.map((option) => {
              const isSelected = selections.sides.includes(option.value);
              return (
                <button
                  key={option.value}
                  onClick={() => handleMultiSelect('sides', option.value)}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className={`font-medium ${isSelected ? 'text-emerald-700' : 'text-stone-800'}`}>
                      {option.label}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        );

      case 'breads':
        return (
          <div className="space-y-6">
            {/* Leivät */}
            <div>
              <h3 className="font-semibold text-stone-700 mb-3">Leivät</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {breadOptions.map((option) => {
                  const isSelected = selections.breads.includes(option.value);
                  return (
                    <button
                      key={option.value}
                      onClick={() => handleMultiSelect('breads', option.value)}
                      className={`p-4 rounded-xl border-2 text-left transition-all ${
                        isSelected 
                          ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                          : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                      }`}
                    >
                      <div className="flex items-center justify-between">
                        <span className={`font-medium ${isSelected ? 'text-emerald-700' : 'text-stone-800'}`}>
                          {option.label}
                        </span>
                        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                          isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                        }`}>
                          {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Levitteet */}
            <div>
              <h3 className="font-semibold text-stone-700 mb-3">Levitteet</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {spreadOptions.map((option) => {
                  const isSelected = selections.spreads.includes(option.value);
                  return (
                    <button
                      key={option.value}
                      onClick={() => handleMultiSelect('spreads', option.value)}
                      className={`p-4 rounded-xl border-2 text-left transition-all ${
                        isSelected 
                          ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                          : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                      }`}
                    >
                      <div className="flex items-center justify-between">
                        <span className={`font-medium ${isSelected ? 'text-emerald-700' : 'text-stone-800'}`}>
                          {option.label}
                        </span>
                        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                          isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                        }`}>
                          {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        );

      case 'desserts':
        return (
          <div className="space-y-6">
            {/* Yes/No choice */}
            <div className="grid grid-cols-2 gap-4">
              <button
                onClick={() => setSelections({ ...selections, wantsDessert: true, desserts: [] })}
                className={`p-4 rounded-xl border-2 transition-all ${
                  selections.wantsDessert === true
                    ? 'border-emerald-500 bg-emerald-50 shadow-md'
                    : 'border-stone-200 hover:border-emerald-300'
                }`}
              >
                <span className={`font-medium ${selections.wantsDessert === true ? 'text-emerald-700' : 'text-stone-800'}`}>
                  Kyllä
                </span>
              </button>
              <button
                onClick={() => setSelections({ ...selections, wantsDessert: false, desserts: [] })}
                className={`p-4 rounded-xl border-2 transition-all ${
                  selections.wantsDessert === false
                    ? 'border-emerald-500 bg-emerald-50 shadow-md'
                    : 'border-stone-200 hover:border-emerald-300'
                }`}
              >
                <span className={`font-medium ${selections.wantsDessert === false ? 'text-emerald-700' : 'text-stone-800'}`}>
                  Ei
                </span>
              </button>
            </div>

            {/* Dessert options if yes */}
            {selections.wantsDessert === true && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                {dessertOptions.map((option) => {
                  const isSelected = selections.desserts.includes(option.value);
                  return (
                    <button
                      key={option.value}
                      onClick={() => handleMultiSelect('desserts', option.value)}
                      className={`p-4 rounded-xl border-2 text-left transition-all ${
                        isSelected 
                          ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                          : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                      }`}
                    >
                      <div className="flex items-center justify-between">
                        <span className={`font-medium ${isSelected ? 'text-emerald-700' : 'text-stone-800'}`}>
                          {option.label}
                        </span>
                        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                          isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                        }`}>
                          {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );

      case 'drinks':
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {drinkOptions.map((option) => {
              const isSelected = selections.drinks.includes(option.value);
              return (
                <button
                  key={option.value}
                  onClick={() => handleMultiSelect('drinks', option.value)}
                  className={`p-4 rounded-xl border-2 text-left transition-all ${
                    isSelected 
                      ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                      : 'border-stone-200 hover:border-emerald-300 hover:bg-emerald-50/50'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className={`font-medium ${isSelected ? 'text-emerald-700' : 'text-stone-800'}`}>
                      {option.label}
                    </span>
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                      isSelected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                    }`}>
                      {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        );

      case 'services':
        const guests = parseInt(selections.guestCount) || 0;
        const recommendedServers = Math.ceil(guests / 25);
        return (
          <div className="space-y-4">
            {/* Tarjoilu */}
            <div className={`rounded-xl border-2 p-4 transition-all ${
              selections.services.tarjoilu.selected ? 'border-emerald-500 bg-emerald-50' : 'border-stone-200'
            }`}>
              <div className="flex items-center justify-between">
                <div>
                  <span className="font-semibold text-stone-800">Tarjoiluhenkilökunta</span>
                  <p className="text-sm text-stone-500">Min. 4h, suositus: {recommendedServers} tarjoilija(a)</p>
                </div>
                <button
                  onClick={() => setSelections({
                    ...selections,
                    services: {
                      ...selections.services,
                      tarjoilu: {
                        ...selections.services.tarjoilu,
                        selected: !selections.services.tarjoilu.selected
                      }
                    }
                  })}
                  className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                    selections.services.tarjoilu.selected ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                  }`}
                >
                  {selections.services.tarjoilu.selected && <CheckCircle className="w-4 h-4 text-white" />}
                </button>
              </div>
              {selections.services.tarjoilu.selected && (
                <div className="mt-3">
                  <Label className="text-sm text-stone-600">Tuntimäärä</Label>
                  <Input
                    type="number"
                    min="4"
                    value={selections.services.tarjoilu.hours}
                    onChange={(e) => setSelections({
                      ...selections,
                      services: {
                        ...selections.services,
                        tarjoilu: {
                          ...selections.services.tarjoilu,
                          hours: parseInt(e.target.value) || 4
                        }
                      }
                    })}
                    className="mt-1 w-24 border-emerald-200"
                  />
                </div>
              )}
            </div>

            {/* Pöytienkattaus */}
            <button
              onClick={() => setSelections({
                ...selections,
                services: { ...selections.services, kattaus: !selections.services.kattaus }
              })}
              className={`w-full rounded-xl border-2 p-4 text-left transition-all ${
                selections.services.kattaus ? 'border-emerald-500 bg-emerald-50' : 'border-stone-200'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <span className="font-semibold text-stone-800">Pöytienkattaus</span>
                  <p className="text-sm text-stone-500">Kattaus valmiiksi tilaisuutta varten</p>
                </div>
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                  selections.services.kattaus ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                }`}>
                  {selections.services.kattaus && <CheckCircle className="w-4 h-4 text-white" />}
                </div>
              </div>
            </button>

            {/* Info about dishes */}
            <div className="bg-emerald-50 rounded-xl p-4 border border-emerald-200">
              <p className="text-sm text-emerald-700 font-medium">Astiavuokraus kysyttäessä!</p>
            </div>
          </div>
        );

      case 'delivery':
        return (
          <div className="space-y-4">
            <p className="text-stone-600 mb-4">Valitse tarvitsemasi kuljetuspalvelut:</p>
            
            {/* Nouto info */}
            <div className="bg-stone-50 rounded-xl p-4 border border-stone-200">
              <p className="text-stone-700">
                <span className="font-semibold">Nouto ravintolasta</span> – ei lisämaksua
              </p>
            </div>

            {/* Kuljetus */}
            <button
              onClick={() => setSelections({
                ...selections,
                delivery: { ...selections.delivery, kuljetus: !selections.delivery.kuljetus }
              })}
              className={`w-full p-4 rounded-xl border-2 text-left transition-all ${
                selections.delivery.kuljetus
                  ? 'border-emerald-500 bg-emerald-50 shadow-md'
                  : 'border-stone-200 hover:border-emerald-300'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <span className={`font-semibold block ${selections.delivery.kuljetus ? 'text-emerald-700' : 'text-stone-800'}`}>
                    Kuljetus perille
                  </span>
                  <span className="text-sm text-stone-500">Toimitamme tilauksesi paikan päälle (Kotka-Hamina alue)</span>
                </div>
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                  selections.delivery.kuljetus ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                }`}>
                  {selections.delivery.kuljetus && <CheckCircle className="w-4 h-4 text-white" />}
                </div>
              </div>
            </button>

            {/* Takaisinvienti */}
            <button
              onClick={() => setSelections({
                ...selections,
                delivery: { ...selections.delivery, takaisinvienti: !selections.delivery.takaisinvienti }
              })}
              className={`w-full p-4 rounded-xl border-2 text-left transition-all ${
                selections.delivery.takaisinvienti
                  ? 'border-emerald-500 bg-emerald-50 shadow-md'
                  : 'border-stone-200 hover:border-emerald-300'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <span className={`font-semibold block ${selections.delivery.takaisinvienti ? 'text-emerald-700' : 'text-stone-800'}`}>
                    Astioiden/välineiden nouto
                  </span>
                  <span className="text-sm text-stone-500">Haemme astiat ja välineet tilaisuuden jälkeen</span>
                </div>
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                  selections.delivery.takaisinvienti ? 'border-emerald-500 bg-emerald-500' : 'border-stone-300'
                }`}>
                  {selections.delivery.takaisinvienti && <CheckCircle className="w-4 h-4 text-white" />}
                </div>
              </div>
            </button>
          </div>
        );

      case 'contact':
        return (
          <div className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <Label className="text-stone-700 font-medium">Nimi *</Label>
                <Input
                  value={selections.contact.name}
                  onChange={(e) => handleContactChange('name', e.target.value)}
                  className="mt-1 border-2 border-stone-200 rounded-xl"
                  placeholder="Nimesi"
                />
              </div>
              <div>
                <Label className="text-stone-700 font-medium">Puhelin *</Label>
                <Input
                  value={selections.contact.phone}
                  onChange={(e) => handleContactChange('phone', e.target.value)}
                  className="mt-1 border-2 border-stone-200 rounded-xl"
                  placeholder="Puhelinnumero"
                />
              </div>
            </div>
            <div>
              <Label className="text-stone-700 font-medium">Sähköposti *</Label>
              <Input
                type="email"
                value={selections.contact.email}
                onChange={(e) => handleContactChange('email', e.target.value)}
                className="mt-1 border-2 border-stone-200 rounded-xl"
                placeholder="sahkoposti@esimerkki.fi"
              />
            </div>
            <div>
              <Label className="text-stone-700 font-medium">Tilaisuuden päivämäärä</Label>
              <Input
                type="date"
                value={selections.contact.date}
                onChange={(e) => handleContactChange('date', e.target.value)}
                className="mt-1 border-2 border-stone-200 rounded-xl"
              />
            </div>
            <div>
              <Label className="text-stone-700 font-medium">Lisätiedot</Label>
              <Textarea
                value={selections.contact.message}
                onChange={(e) => handleContactChange('message', e.target.value)}
                className="mt-1 border-2 border-stone-200 rounded-xl"
                placeholder="Kerro lisätietoja tilaisuudesta..."
                rows={3}
              />
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white">
      {/* Hero */}
      <section className="py-12 md:py-16 bg-gradient-to-br from-stone-800 via-stone-900 to-stone-800 relative overflow-hidden">
        <div className="absolute top-10 left-10 w-32 h-32 border-4 border-emerald-500/20 rounded-full" />
        <div className="absolute bottom-10 right-10 w-48 h-48 border-4 border-emerald-500/10 rounded-full" />
        
        <div className="relative max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 bg-emerald-500/20 backdrop-blur-sm text-emerald-300 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Calculator className="w-4 h-4" />
            <span>Pitopalvelun hintalaskuri</span>
          </div>
          <p className="text-lg text-stone-300 max-w-2xl mx-auto">
            Rakenna oma pitopalvelukokonaisuutesi ja saat suuntaa-antavan hinnan. 
            Valitse ruokalajit, lisukkeet ja palvelut – me hoidamme loput!
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Form Area */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-3xl shadow-xl p-6 md:p-8 border-2 border-emerald-100">
                {/* Progress bar */}
                <div className="mb-8">
                  <div className="flex justify-between text-sm text-stone-500 mb-2">
                    <span>Vaihe {currentStep + 1}/{steps.length}</span>
                    <span>{Math.round(progress)}% valmis</span>
                  </div>
                  <div className="h-2 bg-stone-100 rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-gradient-to-r from-emerald-500 to-emerald-500 rounded-full transition-all duration-500"
                      style={{ width: `${progress}%` }}
                    />
                  </div>
                </div>

                {/* Step Content */}
                <div className="min-h-[400px]">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-emerald-500 rounded-xl flex items-center justify-center shadow-lg">
                      <currentStepData.icon className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h2 className="text-2xl font-bold text-stone-800">{currentStepData.title}</h2>
                      <p className="text-stone-500">{currentStepData.subtitle}</p>
                    </div>
                  </div>

                  {renderStepContent()}
                </div>

                {submitStatus === 'error' && (
                  <div
                    className="flex items-start gap-3 bg-red-50 border-2 border-red-200 rounded-2xl p-4 text-red-800 mt-6"
                    data-testid="catering-error"
                  >
                    <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
                    <div className="text-sm">
                      <p className="font-semibold mb-0.5">Lähetys epäonnistui</p>
                      <p>{submitError}</p>
                    </div>
                  </div>
                )}

                {/* Navigation */}
                <div className="flex flex-col-reverse sm:flex-row sm:justify-between gap-3 mt-8 pt-6 border-t border-stone-100">
                  <Button
                    onClick={prevStep}
                    disabled={currentStep === 0}
                    variant="outline"
                    className="w-full sm:w-auto border-2 border-stone-300 rounded-xl px-4 sm:px-6 py-3 disabled:opacity-50"
                  >
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Edellinen
                  </Button>
                  
                  {currentStep === steps.length - 1 ? (
                    <Button
                      onClick={handleSubmit}
                      disabled={!canProceed() || submitStatus === 'sending'}
                      data-testid="catering-submit-button"
                      className="w-full sm:w-auto bg-gradient-to-r from-emerald-500 to-emerald-500 hover:from-emerald-600 hover:to-emerald-600 text-white rounded-xl px-4 sm:px-8 py-3 disabled:opacity-50"
                    >
                      {submitStatus === 'sending' ? (
                        <>
                          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                          Lähetetään...
                        </>
                      ) : (
                        <>
                          Lähetä tarjouspyyntö
                          <Send className="w-4 h-4 ml-2" />
                        </>
                      )}
                    </Button>
                  ) : (
                    <Button
                      onClick={nextStep}
                      disabled={!canProceed()}
                      className="w-full sm:w-auto bg-stone-900 hover:bg-stone-800 text-white rounded-xl px-4 sm:px-6 py-3 disabled:opacity-50"
                    >
                      Seuraava
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  )}
                </div>
              </div>
            </div>

            {/* Price Summary Sidebar */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-3xl shadow-xl p-6 border-2 border-emerald-100 sticky top-24">
                <h3 className="font-bold text-lg text-stone-800 mb-4 flex items-center gap-2">
                  <Calculator className="w-5 h-5 text-emerald-500" />
                  Yhteenveto
                </h3>
                
                {selections.guestCount && parseInt(selections.guestCount) >= 10 ? (
                  <>
                    <div className="space-y-3 mb-6 text-sm">
                      <div className="flex justify-between">
                        <span className="text-stone-600">Henkilömäärä</span>
                        <span className="font-medium text-stone-800">{selections.guestCount} hlö</span>
                      </div>
                      
                      {/* Menu items summary */}
                      {selections.starters.length > 0 && (
                        <div className="flex justify-between">
                          <span className="text-stone-600">Alkupalat</span>
                          <span className="text-stone-800">{selections.starters.length} kpl</span>
                        </div>
                      )}

                      {selections.coldBuffet.length > 0 && (
                        <div className="flex justify-between">
                          <span className="text-stone-600">Kylmäpöytä</span>
                          <span className="text-stone-800">{selections.coldBuffet.length} kpl</span>
                        </div>
                      )}
                          
                          {selections.salads.length > 0 && (
                            <div className="flex justify-between">
                              <span className="text-stone-600">Salaatit</span>
                              <span className="text-stone-800">{selections.salads.length} kpl</span>
                            </div>
                          )}
                          
                          {Object.values(selections.mainCourses).some(m => m.selected) && (
                            <div className="flex justify-between">
                              <span className="text-stone-600">Pääruoat</span>
                              <span className="text-stone-800">
                                {Object.values(selections.mainCourses).filter(m => m.selected && m.dish).length} kpl
                              </span>
                            </div>
                          )}
                          
                          {selections.sides.length > 0 && (
                            <div className="flex justify-between">
                              <span className="text-stone-600">Lisukkeet</span>
                              <span className="text-stone-800">{selections.sides.length} kpl</span>
                            </div>
                          )}
                          
                          {selections.breads.length > 0 && (
                            <div className="flex justify-between">
                              <span className="text-stone-600">Leivät</span>
                              <span className="text-stone-800">{selections.breads.length} kpl</span>
                            </div>
                          )}

                          {selections.spreads.length > 0 && (
                            <div className="flex justify-between">
                              <span className="text-stone-600">Levitteet</span>
                              <span className="text-stone-800">{selections.spreads.length} kpl</span>
                            </div>
                          )}
                          
                          {selections.desserts.length > 0 && (
                            <div className="flex justify-between">
                              <span className="text-stone-600">Jälkiruoat</span>
                              <span className="text-stone-800">{selections.desserts.length} kpl</span>
                            </div>
                          )}
                          
                          {selections.drinks.length > 0 && (
                            <div className="flex justify-between">
                              <span className="text-stone-600">Juomat</span>
                              <span className="text-stone-800">{selections.drinks.length} kpl</span>
                            </div>
                          )}
                    </div>
                    
                    <div className="border-t border-stone-200 pt-4">
                      <div className="flex justify-between items-center">
                        <span className="font-semibold text-stone-800">Yhteensä</span>
                        <div className="text-right">
                          <span className="text-2xl font-bold text-emerald-600">{totalPrice.toFixed(2)}€</span>
                          <p className="text-xs text-stone-500">sis. alv 13,5%</p>
                        </div>
                      </div>
                    </div>
                    
                    <p className="text-xs text-stone-500 mt-4 bg-emerald-50 p-3 rounded-xl">
                      Hinta päivittyy valintojen mukaan. Lopullinen hinta vahvistetaan tilauksessa.
                    </p>
                  </>
                ) : (
                  <div className="text-center py-8 text-stone-400">
                    <Calculator className="w-10 h-10 mx-auto mb-3 opacity-50" />
                    <p className="text-sm">Syötä henkilömäärä (min. 10) nähdäksesi hinnan</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BuffetkoneePage;
